<template>
  <v-container style="height:100vh">
    <v-row
      align="center"
      justify="center"
      class="py-5 fill-height"
      data-aos="fade-right"
    >
      <v-col cols="12" md="6" order-md="first" order="last">
        <h1 v-html="title"></h1>
        <p>{{ text }}</p>
        <v-img
          v-if="img3"
          :src="require(`@/assets/${img3}`)"
          width="50%"
          class="mt-5"
          contain
        ></v-img>
      </v-col>
      <v-col cols="12" md="6" order-md="last" order="fisrt">
        <v-img
          :src="require(`@/assets/${img}`)"
          max-height="80vh"
          contain
          data-aos="fade-left"
          v-if="$vuetify.breakpoint.mdAndUp"
        ></v-img>
        <v-img
          :src="require(`@/assets/${img2}`)"
          contain
          data-aos="fade-left"
          v-else
        ></v-img>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  props: {
    img: String,
    img2: String,
    img3: String,
    title: String,
    text: String
  }
};
</script>

<style lang="scss" scoped>
#card {
  position: relative;
  * {
    z-index: 1;
  }
  #inner-card {
    @media (min-width: 992px) {
      display: block;
      width: 75%;
    }
    @media (min-width: 1200px) {
      width: 100%;
    }
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
    z-index: 0;
    position: absolute;
    left: 30%;
    width: 100%;
    height: 120%;
  }
}
</style>
